import { Plus, Trash2, MessageSquare } from "lucide-react";

export const HistoryPanel = ({ conversations, activeId, onOpen, onNew, onDelete }) => (
  <div className="flex flex-col h-full" data-testid="chat-history-sidebar">
    <button onClick={onNew} data-testid="btn-new-chat" className="btn-aurora rounded-xl py-2.5 text-xs uppercase flex items-center justify-center gap-2 mb-4">
      <Plus size={15} /> Nuova conversazione
    </button>
    <p className="hud-tag mb-2">Cronologia</p>
    <div className="flex-1 overflow-y-auto space-y-1 pr-1">
      {conversations.length === 0 && <p className="text-xs text-slate-500 py-4">Nessuna conversazione ancora.</p>}
      {conversations.map((c) => (
        <div key={c.id} className={`group flex items-center gap-2 rounded-lg px-2.5 py-2 cursor-pointer transition-colors duration-200 ${c.id === activeId ? "bg-cyan-500/15 border border-cyan-400/30" : "hover:bg-white/5 border border-transparent"}`}
          onClick={() => onOpen(c.id)} data-testid={`history-item-${c.id}`}>
          <MessageSquare size={14} className="text-cyan-400/70 shrink-0" />
          <span className="text-sm text-slate-300 truncate flex-1">{c.title}</span>
          <button onClick={(e) => { e.stopPropagation(); onDelete(c.id); }} data-testid={`history-delete-${c.id}`}
            className="opacity-60 sm:opacity-0 group-hover:opacity-100 text-slate-500 hover:text-rose-400 transition-opacity"><Trash2 size={14} /></button>
        </div>
      ))}
    </div>
  </div>
);
